/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {LabelTypography} from '@ion/dls/src/typography/LabelTypography';

const useStyles = makeStyles(() => {
  return {
    badge : {
      color           : `${dlsColor('white')}`,
      padding         : '2px 4px 2px 5.5px',
      backgroundColor : `${dlsColor('grey4')}`,
      borderRadius    : '4px'
    }
  };
});

/**
 * NoDataBadge is a simple component that displays "No Data" text within a rounded badge.
 * 
 * ```typescript
 * import NoDataBadge from '@ion/dls/src/badges/NoDataBadge;'
 * 
 * <NoDataBadge />
 * ```
 */
export const NoDataBadge = () => {
  const classes = useStyles();
  return (
    <LabelTypography>
      <span className={classes.badge}>
        {translate('common:noData.noData')}
      </span>
    </LabelTypography>
  );
};

export default memo(NoDataBadge);
